import React, { useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import RemoteTable from '../RemoteTable/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

export default function Popups() {
  const [showModalCadastrar, setShowModalCadastrar] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [id, setId] = useState(null);
  const [showModalDeletar, setShowModalDeletar] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    titulo: '',
    corpo: '',
    link: '',
    ativo: false,
  });

  const resetForm = () => {
    setFormData({
      id: null,
      titulo: '',
      corpo: '',
      link: '',
      ativo: false,
    });
  };

  const handleInput = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const salvarPopup = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      if (formData.id) {
        await api.put(`/api/popups/${formData.id}`, formData);
        toast.success('Popup atualizado com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } else {
        await api.post('/api/popups', formData);
        toast.success('Popup criado com sucesso!', {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
      setShowModalCadastrar(false);
      resetForm();
      window.location.reload();
    } catch (err) {
      toast.error('Erro ao salvar o popup.', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setEnviando(false);
    }
  };

  const columns = [
    {
      dataField: 'id',
      hidden: true,
    },
    {
      dataField: 'titulo',
      text: 'Título',
      sort: true,
    },
    {
      dataField: 'corpo',
      text: 'Corpo',
      formatter: (celula, valor) => {
        const texto = valor.corpo || '';
        return texto.length > 100 ? `${texto.substring(0, 100)}...` : texto;
      },
    },
    {
      dataField: 'link',
      text: 'Link',
      formatter: (celula, valor) => {
        return (
          <a
            href={valor.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4a76b9' }}
          >
            {valor.link}
          </a>
        );
      },
    },
    {
      dataField: 'ativo',
      text: 'Ativar/Inativar',
      formatter: (celula, valor) => {
        return (
          <label
            key={`switch-${valor.id}-${valor.ativo}`}
            className="switch"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              updateStatus(!valor.ativo, valor.id);
            }}
          >
            {valor.ativo === 1 || valor.ativo === true ? (
              <input type="checkbox" checked readOnly />
            ) : (
              <input type="checkbox" readOnly />
            )}
            <span className="slider round"></span>
          </label>
        );
      },
    },
    {
      text: 'Editar',
      dataField: 'editar',
      formatter: (celular, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            setFormData({
              id: valor.id,
              titulo: valor.titulo || '',
              corpo: valor.corpo || '',
              link: valor.link || '',
              ativo: valor.ativo || false,
            });
            setShowModalCadastrar(true);
          }}
        >
          <FontAwesomeIcon icon={faEdit} style={{ color: '#4a76b9' }} />
        </button>
      ),
    },
    {
      text: 'Deletar',
      dataField: 'deletar',
      formatter: (celular, valor) => (
        <button
          className="btn-limpo f-12 p-1"
          onClick={() => {
            setId(valor.id);
            setShowModalDeletar(true);
          }}
        >
          <i className="fas fa-trash" style={{ color: 'red' }}></i>
        </button>
      ),
    },
  ];

  const handleDelete = async (e) => {
    e.preventDefault();
    setEnviando(true);
    const resultado = await api.delete(`/api/popups/${id}`);

    if (resultado) {
      toast.success('Popup deletado com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      toast.error('Falha ao deletar o popup!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    setEnviando(false);
    setShowModalDeletar(false);
    window.location.reload();
  };

  const updateStatus = async (state, id) => {
    try {
      const resultado = await api.put(`/api/popups/${id}`, {
        ativo: state ? 1 : 0,
      });

      if (resultado) {
        toast.success('Popup atualizado com sucesso', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
        window.location.reload();
      }
    } catch (error) {
      toast.error('Erro ao atualizar popup', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="pt-3 pb-3 f-black">Popups</h4>
        <button
          className="btn-primario"
          onClick={() => {
            resetForm();
            setShowModalCadastrar(true);
          }}
        >
          Novo Popup
        </button>
      </div>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <RemoteTable
          dataId="id"
          url="/api/popups"
          colunas={columns}
          ordenacaoInicial={{ campo: 'id', direcao: 'desc' }}
        />
      </div>

      <Modal
        show={showModalCadastrar}
        onHide={() => {
          setShowModalCadastrar(false);
          resetForm();
        }}
        centered
      >
        <Modal.Header closeButton>
          {formData.id ? 'Editar Popup' : 'Criar Popup'}
        </Modal.Header>
        <Modal.Body>
          <form className="form" onSubmit={(e) => e.preventDefault()}>
            <label>Título *</label>
            <input
              type="text"
              className="form-control mb-2"
              value={formData.titulo}
              onChange={(e) => handleInput('titulo', e.target.value)}
              required
            />

            <label>Corpo (dois parágrafos) *</label>
            <textarea
              className="form-control mb-2"
              rows={6}
              value={formData.corpo}
              onChange={(e) => handleInput('corpo', e.target.value)}
              required
              placeholder="Digite o corpo do popup. Use quebras de linha para separar os parágrafos."
            />

            <label>Link do botão "Responder" *</label>
            <input
              type="url"
              className="form-control mb-2"
              value={formData.link}
              onChange={(e) => handleInput('link', e.target.value)}
              required
              placeholder="https://exemplo.com"
            />

            <div className="mt-3 d-flex align-items-center">
              <input
                type="checkbox"
                id="ativo"
                style={{ margin: 0, height: '25px', marginRight: '6px' }}
                checked={formData.ativo}
                onChange={(e) => handleInput('ativo', e.target.checked)}
              />
              <label htmlFor="ativo" style={{ margin: 0 }}>
                Ativar popup
              </label>
            </div>

            <div className="mt-3 d-flex justify-content-end">
              <button
                className="btn-secundario px-2"
                onClick={() => {
                  setShowModalCadastrar(false);
                  resetForm();
                }}
              >
                Cancelar
              </button>
              <button
                className="btn-primario ml-2"
                onClick={salvarPopup}
                disabled={enviando}
              >
                {enviando ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {showModalDeletar && (
        <div id="modal">
          <div className="conteudoModal">
            <form onSubmit={handleDelete}>
              <span className="textoInativar">
                Tem certeza que deseja deletar o popup?
                <br />
              </span>
              <div className="botoes">
                {!enviando ? (
                  <button type="submit">Deletar</button>
                ) : (
                  <button type="button" disabled>
                    Enviando...
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setShowModalDeletar(false)}
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </Container>
  );
}
